package fyi.moko.hotpl.ui.account

import androidx.compose.runtime.Composable
import fyi.moko.hotpl.domain.usecase.LinkAccountUseCase
import fyi.moko.hotpl.domain.usecase.LinkAccountUseCase.SocialCredential

/**
 * Platform seam that launches the native social sign-in flow and returns the
 * provider's OAuth tokens as a [SocialCredential] — what
 * [fyi.moko.hotpl.data.service.FirebaseAuthService] turns into a Firebase credential
 * via `LinkAccountUseCase`. On failure the [Result] carries
 * [SocialSignInCancelledException] (user backed out) or
 * [SocialSignInUnavailableException] (provider/platform not wired or configured).
 *
 * Mirrors the `rememberImagePicker` pattern: the composable owns the launcher and
 * feeds its callback result back into the ViewModel.
 *
 * Android actual: Credential Manager + Google ID token (access token null). iOS actual:
 * native GIDSignIn (id + access token). JS: not yet supported.
 */
fun interface SocialSignInLauncher {
    fun signIn(provider: LinkAccountUseCase.Provider, onResult: (Result<SocialCredential>) -> Unit)
}

/** The user dismissed/cancelled the sign-in sheet — benign, not an error to shout about. */
class SocialSignInCancelledException(message: String = "Sign-in cancelled") : Exception(message)

/** The provider isn't available on this platform, or isn't configured (e.g. missing client ID). */
class SocialSignInUnavailableException(message: String) : Exception(message)

@Composable
expect fun rememberSocialSignInLauncher(): SocialSignInLauncher
